import factor from "refractor/factor";
export default factor;